import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { TvIcon } from '@heroicons/react/24/solid'
import styles from './Badges.module.css'

const Badges = ({
  isFreeLesson,
  enrolled,
  complete,
  showOneLine,
  hasVideo,
}) => {
  return (
    <div
      className={`${styles.badges} ${showOneLine ? styles.flexOneLine : ''}`}
    >
      {isFreeLesson && <span className={styles.freeLesson}>Free lesson</span>}
      {hasVideo && (
        <TvIcon
          className={styles.svgIncomplete}
          title="Lesson includes a video"
        />
      )}
      {enrolled && (
        <CheckCircleIcon
          className={complete ? styles.svgComplete : styles.svgIncomplete}
        />
      )}
    </div>
  )
}

export default Badges
